import { ClientForm } from '@components/client'
import AddIcon from '@mui/icons-material/Add'
import CloseIcon from '@mui/icons-material/Close'
import PropTypes from 'prop-types'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import classes from './VehicleInfo.module.css'

import {
  requestCreateWO,
  requestSafetySystems,
  updateQuote,
  updateWorkOrder,
  getWorkOrderByReferenceNumber,
  getInvoiceByReferenceNumber,
  getQuoteByReferenceNumber,
  getAttachmentAppointmentEstimate,
  useSubmitFileAttachment
} from '../../api/api'

import { VehicleInfoDetails } from '@components/vehicle-info-details'
import _ from 'lodash'
import { useParams } from 'react-router-dom'

import { useCenterStore } from '@caradasstore/CenterStore'
import { CarImageHolder } from '@components/car-image-holder'
import { VinInput } from '@components/vin'
import {
  AdasBox,
  AdasButton,
  AdasButtonGroup,
  AdasCheckbox,
  AdasContainer,
  AdasDrawer,
  AdasFormControl,
  AdasFormControlLabel,
  AdasFormGroup,
  AdasFormLabel,
  AdasInputLabel,
  AdasPaper,
  AdasRadio,
  AdasRadioGroup,
  AdasSelect,
  AdasTextField,
  AdasTypography,
  AdasAutoComplete
} from '@components/wrapper-components'
import { useHistory, useLocation } from 'react-router-dom'
import { getQuoteSummaryUrl, getWorkOrderSummaryUrl, PARAM_NAMES, REDIRECT_URLS, BUTTONS_DISPLAY_LABEL } from '../../constants'
import { useScrollTop } from '../../utils/useScrollTop'
import { CaradasSnackbar } from '@components/snackbar'
import { GENERIC_MESSAGES } from '../../constants'
import { StatusEnum } from '../../enums/enums'
import { Logger } from '../../logger'
import { useLoadingStore } from '@caradasstore/LoadingStore'
import { ATTACHMENT_TYPE_MAP, MIME_TYPES_MAP } from 'variable-maps'
import { VehicleInfoManuallPage } from './VehicleInfoManuallPage'
import theme from 'theme/theme'
import { useClientAndInsuranceData } from '../../hooks/useClientAndInsuranceData'
import { useInitReferralAndInsuranceFromState } from '@hooks/useInitReferralAndInsuranceFromState'
import { useReferralAutoMatch } from '@hooks/useReferralAutoMatch'
import { ConfirmModal } from '@components/common'
import WarningIcon from '@mui/icons-material/Warning'
export const VehicleInfoPage = (props) => {
  useScrollTop()
  const location = useLocation()
  const referralSourceCode = location.state?.referral
  const { [PARAM_NAMES.REFERENCE_NUMBER]: referenceNumber } = useParams()
  const { fromWorkOrder = false, fromInvoice = false, fromQuote = false, isNewWorkOrder } = props
  const [isAddClient, setIsAddClient] = useState(false)
  const [vehicleData, setVehicleData] = useState({})
  const [displayDetails, setDisplayDetails] = useState(false)
  const [isDrawOpen, setIsDrawOpen] = useState(false)
  const [customerPay, setCustomerPay] = useState(false)
  const [safetySystemItems, setSafetySystemItems] = useState([])
  const [openSnackBar, setOpenSnackBar] = useState(false)
  const [showInsuranceChangeModal, setShowInsuranceChangeModal] = useState(false)
  const [pendingInsuranceCompanyId, setPendingInsuranceCompanyId] = useState(null)
  const [manualOverRideVin, setManualOverRideVin] = useState(false)
  const [preCalRepairEstimateScan, setPreCalRepairEstimateScan] = useState(null)
  const [formInputValues, setFormInputValues] = useState({
    client: '',
    roNumber: '',
    vin: '',
    serviceType: 'STANDARD',
    insurance_company_id: '',
    appointment_id: '',
    referral_source_code: referralSourceCode || null,
    vehicleYear: '',
    vehicleMake: '',
    vehicleModel: '',
    vehicleTrim: ''
  })
  const [workOrderData, setWorkOrderData] = useState({}) //Object holds Quote/WorkOrder/Invoice data
  const prePopulateVin = isNewWorkOrder && (location.state?.prepopulateVin || location.state?.vin)
  const history = useHistory()
  const { uploadData } = useSubmitFileAttachment()

  const [isVinServiceDown, setIsVinServiceDown] = useState(false)
  const redirectToForbiddenPage = () => {
    history.replace(REDIRECT_URLS.FORBIDDEN_PAGE)
  }

  const previousSafetySystemRef = useRef([])
  const ccId = useCenterStore((store) => store.ccId)
  const setLoading = useLoadingStore((store) => store.setLoading)
  const {
    clients,
    insuranceCompanies,
    fetchClients,
    clearVehicleFields,
    fetchReferralSource,
    referralSourceList,
    handleVehicleManualChange
  } = useClientAndInsuranceData(ccId)

  useEffect(() => {
    if (location.state?.appointment_id) {
      setFormInputValues((prevState) => ({
        ...prevState,
        roNumber: location.state?.aro || '',
        appointment_id: location.state?.appointment_id || ''
      }))
    }
  }, [location.state?.appointment_id, setFormInputValues])
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (fromQuote || fromInvoice || fromWorkOrder) {
          setLoading(true)
        }
        if (fromQuote) {
          const quoteResponse = await getQuoteByReferenceNumber({
            referenceNumber: referenceNumber
          })
          if (quoteResponse?.status === 200) {
            quoteResponse.data.quote.safetySystemsItems = quoteResponse.data.safetySystemsItems || []
            setWorkOrderData(quoteResponse.data?.quote)
          } else {
            //Given referenceNumber doesnot exist or no permission granted
            redirectToForbiddenPage()
            return
          }
        }
        if (fromInvoice) {
          let response = await getInvoiceByReferenceNumber({ referenceNumber })
          if (response?.status === 200) {
            if (!response.data?.invoiceDto) {
              redirectToForbiddenPage()
              return
            }
            response.data.invoiceDto.safetySystemsItems = response.data.safetySystemsItems || []
            setWorkOrderData(response.data.invoiceDto)
          } else {
            //Given referenceNumber doesnot exist or no permission granted
            redirectToForbiddenPage()
            return
          }
        }
        if (fromWorkOrder) {
          let response = await getWorkOrderByReferenceNumber({ referenceNumber })
          if (response?.status === 200) {
            //Url Tampared i.e invoice/quote record tried to open in workorder path
            if (StatusEnum[response.data?.workOrder?.status] === StatusEnum.MOVED) {
              redirectToForbiddenPage()
              return
            }
            response.data.workOrder.safetySystemsItems = response.data.safetySystemsItems || []
            setWorkOrderData(response.data.workOrder)
          } else {
            //Given referenceNumber doesnot exist or no permission granted
            redirectToForbiddenPage()
            return
          }
        }
      } catch (error) {
        Logger.error({
          message: error,
          payload: {
            referenceNumber
          }
        })
      } finally {
        setLoading(false)
      }
    }
    if (!(isNewWorkOrder && location.state?.prepopulateVin) && referenceNumber) fetchData()
  }, [referenceNumber])

  useEffect(() => {
    // if not a new workorder, we need to get data from location to render vehicle info
    if (!isNewWorkOrder) {
      const clientId = workOrderData.client?.id

      const updateValues = {
        client: clientId,
        roNumber: workOrderData.repair_order_num,
        insurance_company_id: workOrderData?.insurance_company?.id,
        vin: workOrderData?.vehicle?.vin || ''
      }
      setFormInputValues(updateValues)
      setCustomerPay(workOrderData.repair_order_num === 'Customer-Pay')

      const existingVehicleData = {
        ...workOrderData.vehicle,
        color: workOrderData.vehicle?.exterior_color,
        imageUrl: workOrderData.vehicle?.image_url,
        safetySystemsItems: workOrderData.safetySystemsItems || []
      }
      setDisplayDetails(true)
      setVehicleData(existingVehicleData)
    }
  }, [
    workOrderData?.client?.id,
    workOrderData?.repair_order_num,
    workOrderData?.safetySystemsItems,
    workOrderData?.vehicle,
    workOrderData?.insurance_company_dto?.id,
    isNewWorkOrder
  ])

  const title = props.title

  const isEnabled = useMemo(() => {
    const clientValid = !!formInputValues.client

    const vinValid =
      (!!formInputValues.vin && !manualOverRideVin && !isVinServiceDown) ||
      (manualOverRideVin &&
        formInputValues.vehicleYear &&
        formInputValues.vehicleMake &&
        formInputValues.vehicleModel &&
        formInputValues.vehicleTrim) ||
      referenceNumber

    const roNumberValid = customerPay || !!formInputValues.roNumber
    const isInsuranceCompanyValid = !!formInputValues.insurance_company_id

    return vinValid && clientValid && roNumberValid && isInsuranceCompanyValid
  }, [
    customerPay,
    formInputValues.client,
    formInputValues.vin,
    formInputValues.roNumber,
    formInputValues.vehicleYear,
    formInputValues.vehicleMake,
    formInputValues.vehicleModel,
    formInputValues.vehicleTrim,
    isVinServiceDown,
    formInputValues.insurance_company_id
  ])

  const redirectWorkOrderSummary = useCallback(
    async (data) => {
      if (fromQuote) {
        history.push(getQuoteSummaryUrl(data?.quote?.reference_number ?? data?.reference_number))
      } else {
        history.push(getWorkOrderSummaryUrl(data?.workOrder?.reference_number ?? data?.reference_number))
      }
    },
    [fromInvoice, fromQuote, history]
  )

  const changeHandler = useCallback(
    (e) => {
      setFormInputValues((prevValues) => {
        return { ...prevValues, [e.target.name]: e.target.value }
      })
    },
    [setFormInputValues]
  )

  const { autoMatchedReferral, setAutoMatchedReferral, showReferralField, setShowReferralField, matchReferral } = useReferralAutoMatch({
    insuranceCompanies,
    referralSourceList,
    setFormInputValues,
    referralSourceCode
  })

  useInitReferralAndInsuranceFromState({
    referralSourceCode,
    insuranceCompanies,
    setFormInputValues,
    setAutoMatchedReferral: setAutoMatchedReferral, // optional, only in VehicleInfoPage
    setShowReferralField,
    ccId: ccId
  })
  const handleShowReferralField = useCallback(
    (e) => {
      const isYesSelected = e.target.value === 'true'
      setShowReferralField(isYesSelected)

      setFormInputValues((prev) => {
        const updated = { ...prev }

        if (isYesSelected) {
          matchReferral(prev.insurance_company_id)
        } else {
          updated.referral_source_code = null
        }

        return updated
      })
    },
    [matchReferral]
  )

  const handleCustomerPay = useCallback((e) => {
    const value = /true/.test(e.target.value)
    const roNumber = value ? 'Customer-Pay' : ''
    setCustomerPay(value)
    setFormInputValues((prevValues) => {
      return { ...prevValues, roNumber: roNumber }
    })
  }, [])

  const openSafetySystem = useCallback(() => {
    requestSafetySystems({})
      .then((response) => {
        if (response?.status === 200) {
          let allSafetySystems = []
          response.data?.forEach((system) =>
            allSafetySystems.push({
              safety_system_master_id: system.id,
              checked: false,
              ...system
            })
          )
          if (vehicleData && vehicleData.safetySystemsItems && vehicleData.safetySystemsItems.length > 0) {
            vehicleData.safetySystemsItems.forEach((safety) => {
              const matchingSystem = allSafetySystems.find((item) => item.unique_key === safety.unique_key)
              if (matchingSystem) {
                matchingSystem.checked = true
              }
            })
          }
          setIsDrawOpen(true)
          allSafetySystems.sort((a, b) => a.feature_name?.toLowerCase().localeCompare(b.feature_name?.toLowerCase()))
          setSafetySystemItems(allSafetySystems)
        }
      })
      .catch((err) => {
        console.log('ERROR ', err)
      })
  }, [vehicleData])

  const uploadFile = useCallback(
    async (file, type, id) => {
      const formData = new FormData()
      formData.append('file', file, file.name)
      let attachmentType = ATTACHMENT_TYPE_MAP[type]
      const params = {
        data: formData,
        workorderId: id,
        type: 'workorders',
        attachmentType
      }

      const response = uploadData(params)
      response.then(() => {})
    },
    [uploadData]
  )

  useEffect(() => {
    const fetchFileData = async (value) => {
      try {
        const response = await getAttachmentAppointmentEstimate(ccId, value.appointment_id)
        const fileFromResponse = new File([response.data], value.name, {
          type: MIME_TYPES_MAP[`.${value.file_extension}`] // Ensure the correct MIME type is used
        })

        setPreCalRepairEstimateScan(fileFromResponse)
      } catch (error) {
        Logger.error({ message: error.message, payload: { value } })
      }
    }

    if (location.state?.recentEstimate?.id) {
      fetchFileData(location.state?.recentEstimate)
    }
  }, [location.state?.recentEstimate?.id])

  const submitHandler = useCallback(async () => {
    setLoading(true)
    const { color, imageUrl, fuel, ...vehicle } = vehicleData
    const workOrderRequestData = {
      referral_source_code: formInputValues.referral_source_code,
      client_id: formInputValues.client,
      calibration_center_id: ccId,
      repair_order_num: formInputValues.roNumber,
      quote: fromQuote,
      type: formInputValues.serviceType,
      insurance_company_id: formInputValues.insurance_company_id,
      vehicle: {
        vin: formInputValues.vin,
        calibration_center_id: ccId,
        exterior_color: color,
        image_url: imageUrl,
        fuel_capacity_gal: fuel,
        safetySystemsItems:
          vehicleData.safetySystemsItems?.map((item) => {
            return item
          }) || [],
        year: isVinServiceDown && formInputValues.vehicleYear ? formInputValues.vehicleYear : vehicle.year,
        make: isVinServiceDown && formInputValues.vehicleMake ? formInputValues.vehicleMake : vehicle.make,
        model: isVinServiceDown && formInputValues.vehicleModel ? formInputValues.vehicleModel : vehicle.model,
        trim: isVinServiceDown && formInputValues.vehicleTrim ? formInputValues.vehicleTrim : vehicle.trim,
        ...vehicle
      },
      appointment_id: formInputValues.appointment_id
    }
    try {
      const response = await requestCreateWO({ data: workOrderRequestData })
      if (response.status === 201) {
        const id = response.data.workOrder.id
        if (preCalRepairEstimateScan) {
          uploadFile(preCalRepairEstimateScan, 'preCalRepairEstimateScan', id)
        }

        setLoading(false)
        redirectWorkOrderSummary(response.data)
      }
    } catch (err) {
      Logger.error({ message: err, payload: { file: 'VehicleInfoPage/submitHandler' }, workOrderRequestData })
    } finally {
      setLoading(false)
    }
  }, [
    ccId,
    formInputValues.client,
    formInputValues.roNumber,
    formInputValues.serviceType,
    formInputValues.vin,
    fromQuote,
    redirectWorkOrderSummary,
    vehicleData,
    formInputValues.vehicleYear,
    formInputValues.vehicleMake,
    formInputValues.vehicleModel,
    formInputValues.vehicleTrim,
    formInputValues.insurance_company_id
  ])

  const handleSafetySystemChange = useCallback(
    (e) => {
      const uniqueKey = e.target.value
      setSafetySystemItems((prevItems) => {
        const updatedItems = prevItems.map((item) => (item.unique_key === uniqueKey ? { ...item, checked: e.target.checked } : item))
        updatedItems.sort((a, b) => a.feature_name?.toLowerCase().localeCompare(b.feature_name?.toLowerCase()))
        return updatedItems
      })
    },
    [safetySystemItems]
  )

  const handleCloseSafetySystemEdit = useCallback(() => {
    const newSafetySystem = safetySystemItems
      .filter((item) => item.checked)
      .map((item) => ({
        ...item,
        id: null
      }))

    previousSafetySystemRef.current = vehicleData.safetySystemsItems
      .map((item) => {
        if (item.feature_name) {
          return {
            ...item
          }
        }
        return null
      })
      .filter(Boolean)

    setVehicleData((prevValues) => {
      const updateValues = {
        ...prevValues,
        safetySystemsItems: newSafetySystem
      }
      return updateValues
    })

    setIsDrawOpen(false)

    const sortedPreviousSafetySystemRef = _.sortBy(previousSafetySystemRef.current, 'feature_name')

    if (!_.isEqual(newSafetySystem, sortedPreviousSafetySystemRef)) {
      //setOpenSnackBar(true) // Open the snackbar if there are differences //hiding undo
    }
  }, [safetySystemItems, vehicleData.safetySystemsItems])

  const undoSafetySystemHandler = useCallback(() => {
    setVehicleData((prevState) => {
      const data = {
        ...prevState,
        safetySystemsItems: previousSafetySystemRef.current
      }
      return data
    })
    setOpenSnackBar(false)
  }, [])

  const updateVehicleInfo = async () => {
    // eslint-disable-next-line no-unused-vars
    const { safetySystemsItems, color, imageUrl, fuel, ...vehicle } = vehicleData
    if (fromQuote) {
      const submitData = {
        id: workOrderData.id,
        client_id: formInputValues.client,
        calibration_center_id: ccId,
        repair_order_num: formInputValues.roNumber,
        insurance_company_id: formInputValues.insurance_company_id,
        referral_source_code: formInputValues.referral_source_code,
        quote: fromQuote,
        vehicle: {
          vin: formInputValues.vin,
          calibration_center_id: ccId,
          exterior_color: color,
          image_url: imageUrl,
          fuel_capacity_gal: fuel,
          safetySystemsItems: safetySystemsItems,
          ...vehicle
        }
      }

      try {
        const response = await updateQuote({
          data: submitData,
          quoteId: submitData.id
        })

        if (response.status === 200) {
          redirectWorkOrderSummary(response.data)
        }
      } catch (err) {
        Logger.error({ message: err, payload: { file: 'VehicleInfoPage/updateVehicleInfo/fromQuote', submitData } })
      }
    } else {
      const data = {
        workorder_id: workOrderData.id,
        client_id: formInputValues.client,
        repair_order_num: formInputValues.roNumber,
        insurance_company_id: formInputValues.insurance_company_id,
        referral_source_code: formInputValues.referral_source_code,
        safetySystems: safetySystemsItems
      }

      try {
        const response = await updateWorkOrder({
          data: data
        })

        if (response.status === 200) {
          history.goBack()
        }
      } catch (err) {
        Logger.error({ message: err, payload: { file: 'VehicleInfoPage/updateVehicleInfo', data } })
      }
    }
  }

  const updateVehicleDetails = useCallback(
    (props) => {
      setDisplayDetails(true)
      setVehicleData({ ...props.data, safetySystemsItems: props.data?.safetySystems })
      setFormInputValues((prevValues) => {
        const updatedValues = {
          ...prevValues,
          vin: props.vin
        }
        return updatedValues
      })
    },
    [setDisplayDetails, setVehicleData, setFormInputValues]
  )

  const isReferralInsurance = useCallback(
    (insuranceCompanyId) => {
      const selectedInsurance = insuranceCompanies.find((company) => company.id === insuranceCompanyId)
      return referralSourceList.some((referral) => referral.value?.toLowerCase() === selectedInsurance?.name?.toLowerCase())
    },
    [insuranceCompanies, referralSourceList]
  )

  const autocompleteHandler = useCallback(
    (event) => {
      const { name, value } = event.target
      if (name === 'insurance_company_id') {
        if (value === formInputValues.insurance_company_id) {
          return
        }
        if (!isNewWorkOrder && (isReferralInsurance(value) || isReferralInsurance(formInputValues.insurance_company_id))) {
          setPendingInsuranceCompanyId(value)
          setShowInsuranceChangeModal(true)
          return
        }
      }

      setFormInputValues((prevValues) => ({
        ...prevValues,
        [name]: value || ''
      }))

      // Match referral only when changing insurance
      if (name === 'insurance_company_id') {
        matchReferral(value)
      }
    },
    [formInputValues.insurance_company_id, isNewWorkOrder, isReferralInsurance, matchReferral, setFormInputValues]
  )

  const handleInsuranceChangeConfirm = useCallback(() => {
    if (!pendingInsuranceCompanyId) {
      setShowInsuranceChangeModal(false)
      return
    }

    setFormInputValues((prevValues) => ({
      ...prevValues,
      insurance_company_id: pendingInsuranceCompanyId
    }))
    matchReferral(pendingInsuranceCompanyId)
    setPendingInsuranceCompanyId(null)
    setShowInsuranceChangeModal(false)
  }, [matchReferral, pendingInsuranceCompanyId])

  const handleInsuranceChangeCancel = useCallback(() => {
    setPendingInsuranceCompanyId(null)
    setShowInsuranceChangeModal(false)
  }, [])

  const handleVehicleManuallChange = (eventOrValue) => {
    handleVehicleManualChange(eventOrValue, setFormInputValues)
  }

  useEffect(() => {
    if (isNewWorkOrder && isVinServiceDown) {
      clearVehicleFields(setFormInputValues)
      setManualOverRideVin(false)
    }
  }, [isNewWorkOrder, isVinServiceDown])

  useEffect(() => {
    clearVehicleFields(setFormInputValues)
  }, [manualOverRideVin])

  useEffect(() => {
    fetchReferralSource()
  }, [fetchReferralSource])

  const disableEdit = workOrderData ? StatusEnum[workOrderData.status] === StatusEnum.CLOSED || fromInvoice : false

  return (
    <AdasContainer maxWidth='lg'>
      <AdasPaper
        elevation={0}
        sx={{
          padding: '1.25rem',
          marginTop: '1.25rem',
          marginBottom: '20px'
        }}
      >
        {isAddClient && (
          <AdasDrawer anchor={'right'} open={isAddClient} onClose={() => setIsAddClient(false)}>
            <AdasBox className='drawer-title-container'>
              <AdasTypography variant='h6'>Client Info</AdasTypography>
              <AdasButton
                buttonType='iconButton'
                sx={{
                  padding: '2px',
                  cursor: 'pointer',
                  color: theme.palette.info.main
                }}
                onClick={() => setIsAddClient(false)}
              >
                <CloseIcon fontSize='small' />
              </AdasButton>
            </AdasBox>
            <ClientForm onSaveSuccess={fetchClients} clibrationCenterId={Number(ccId)} close={() => setIsAddClient(false)} />
          </AdasDrawer>
        )}
        <AdasDrawer anchor={'right'} open={isDrawOpen} onClose={handleCloseSafetySystemEdit}>
          <AdasBox className='drawer-title-container'>
            <AdasTypography variant='h6'>Installed Safety Systems</AdasTypography>
            <AdasButton
              buttonType='iconButton'
              sx={{
                padding: '2px',
                cursor: 'pointer',
                color: theme.palette.info.main
              }}
              onClick={handleCloseSafetySystemEdit}
            >
              <CloseIcon fontSize='small' />
            </AdasButton>
          </AdasBox>
          <AdasFormGroup className={classes.drawer}>
            {safetySystemItems.map((system, index) => {
              return (
                <AdasFormControlLabel
                  className={classes.description}
                  key={index}
                  control={
                    <AdasCheckbox
                      label={system.feature_name}
                      checked={system.checked}
                      onChange={handleSafetySystemChange}
                      value={system.unique_key}
                    ></AdasCheckbox>
                  }
                  label={system.feature_name}
                />
              )
            })}
          </AdasFormGroup>
        </AdasDrawer>
        <AdasBox>
          <h1 style={{ fontSize: '28px', fontWeight: '400' }}>{title}</h1>
          <AdasFormControl fullWidth>
            <AdasButtonGroup sx={{ boxShadow: 'none' }} variant='contained' aria-label='outlined primary button group'>
              <AdasInputLabel id='clients-label'>Select Client</AdasInputLabel>
              <AdasSelect
                label='Select Client'
                labelId='clients-label'
                name='client'
                value={formInputValues.client}
                onChange={autocompleteHandler}
                disabled={disableEdit}
                options={clients || []}
                sx={{
                  maxHeight: '100px',
                  overflowY: 'auto',
                  width: '90%',
                  textAlign: 'left',
                  borderTopLeftRadius: '4px',
                  borderBottomLeftRadius: '4px',
                  '.MuiOutlinedInput-root': {
                    borderTopRightRadius: '0px',
                    borderBottomRightRadius: '0px'
                  }
                }}
              />
              <AdasButton
                onClick={() => setIsAddClient(true)}
                disabled={disableEdit}
                sx={{
                  width: '10%',
                  height: '56px',
                  borderRadius: '0',
                  paddingTop: '0px',
                  paddingBottom: '0px',
                  borderTopRightRadius: '4px',
                  borderBottomRightRadius: '4px'
                }}
                variant='contained'
              >
                <AddIcon />
              </AdasButton>
            </AdasButtonGroup>
            <AdasBox sx={{ margin: '.5rem 1rem', textAlign: 'left' }}>
              <AdasFormLabel id='repair-order-label' align='left'>
                Repair Order
              </AdasFormLabel>
              <AdasRadioGroup
                row
                options={[
                  { label: 'RO Provided', value: false },
                  { label: 'Customer Pay', value: true }
                ]}
                disabled={disableEdit}
                name='clientPay'
                value={customerPay}
                onChange={handleCustomerPay}
              />
            </AdasBox>

            <AdasTextField
              id='outlined-basic'
              label='RO #'
              variant='outlined'
              sx={{
                paddingTop: '5px'
              }}
              className={classes.formField}
              disabled={customerPay || disableEdit}
              name='roNumber'
              onChange={changeHandler}
              value={formInputValues.roNumber}
            />
          </AdasFormControl>
          <AdasFormControl fullWidth sx={{ marginTop: '20px' }}>
            <AdasAutoComplete
              labelId='insurance_label'
              id='insurance_company_id'
              name='insurance_company_id'
              label='Insurance Company (Required)'
              value={formInputValues.insurance_company_id}
              onChange={autocompleteHandler}
              disabled={disableEdit}
              options={insuranceCompanies || []}
              sx={{ width: '100%', textAlign: 'left' }}
            />
          </AdasFormControl>
          {isNewWorkOrder
            ? [
                <>
                  {!autoMatchedReferral?.id && (
                    <>
                      {/* future reference commented below code */}
                      {/* <AdasBox sx={{ margin: '1rem 1rem', textAlign: 'left' }}>
                        <AdasFormLabel id='referral-source-label' align='left'>
                          Do you have a referral source?
                        </AdasFormLabel>
                        <AdasRadioGroup
                          row
                          options={[
                            { value: true, label: 'Yes' },
                            { value: false, label: 'No' }
                          ]}
                          disabled={!!referralSourceCode}
                          name='referral-radio-group'
                          value={showReferralField}
                          onChange={handleShowReferralField}
                        />
                      </AdasBox> */}
                      {/* future reference commented below code */}
                      {/* {showReferralField && (
                        <>
                          <AdasFormControl fullWidth>
                            {referralSourceList.length > 0 ? (
                              <>
                                <AdasInputLabel id='referral_label'>Referral Source</AdasInputLabel>
                                <AdasSelect
                                  labelId='referral_label'
                                  id='referral_label'
                                  name='referral_source_code'
                                  label='Referral Source'
                                  value={formInputValues.referral_source_code || ''}
                                  onChange={autocompleteHandler}
                                  options={referralSourceList}
                                  sx={{
                                    width: '100%',
                                    textAlign: 'left'
                                  }}
                                />
                              </>
                            ) : !referralSourceCode ? (
                              <>
                                <AdasAlert
                                  severity='warning'
                                  sx={{
                                    backgroundColor: '#FFFBE6',
                                    border: '1px solid #FFE58F',
                                    color: '#614700',
                                    borderRadius: '8px'
                                  }}
                                >
                                  {' '}
                                  Please contact support to enroll in National Agreements
                                </AdasAlert>
                              </>
                            ) : null}
                          </AdasFormControl>
                        </>
                      )} */}
                    </>
                  )}
                  <AdasBox sx={{ margin: '1.25rem 1rem' }} key='radio-box'>
                    <AdasFormControl fullWidth>
                      <AdasFormLabel align='left' id='work-type-label' sx={{ textAlign: 'left', alignContent: 'left' }}>
                        Type
                      </AdasFormLabel>
                      <AdasRadioGroup
                        row
                        options={[
                          { label: 'Standard', value: 'STANDARD' },
                          { label: 'Service Only', value: 'SERVICE_ONLY' }
                        ]}
                        name='serviceType'
                        value={formInputValues.serviceType}
                        onChange={changeHandler}
                      >
                        <AdasFormControlLabel value='standard' control={<AdasRadio />} label='Standard' />
                        <AdasFormControlLabel value='serviceOnly' control={<AdasRadio />} label='Service Only' />
                      </AdasRadioGroup>
                    </AdasFormControl>
                  </AdasBox>
                  <AdasFormLabel
                    key='s1'
                    // align="left"
                    sx={{ textAlign: 'left', marginLeft: '.5rem' }}
                    margin='4px'
                  >
                    Vehicle Details
                  </AdasFormLabel>
                  <VinInput
                    key='vinInput'
                    updateVehicleInfo={updateVehicleDetails}
                    prepopulateVin={prePopulateVin}
                    vinExistCheck={true}
                    setIsVinServiceDown={setIsVinServiceDown}
                  />
                </>
              ]
            : null}
          {!isVinServiceDown && (
            <>
              {displayDetails ? (
                <VehicleInfoDetails data={vehicleData} qwi={referenceNumber} openDraw={openSafetySystem} disabled={disableEdit} />
              ) : (
                <CarImageHolder />
              )}
            </>
          )}
          {isNewWorkOrder && isVinServiceDown && (
            <>
              <AdasBox sx={{ ml: '1rem', mt: '0.5rem' }}>
                <AdasFormLabel key='s1' sx={{ fontWeight: '400', color: '#000000', fontStyle: 'italic' }}>
                  If VIN results in an error message, select Manually Enter Vehicle Details below
                </AdasFormLabel>
              </AdasBox>
              <VehicleInfoManuallPage
                formInputValues={formInputValues}
                setFormInputValues={setFormInputValues}
                handleVehicleManuallChange={handleVehicleManuallChange}
                manualOverRideVin={manualOverRideVin}
                setManualOverRideVin={setManualOverRideVin}
              />
            </>
          )}
        </AdasBox>
        <AdasBox className={classes.submit}>
          {isNewWorkOrder
            ? [
                <AdasButton
                  key='1'
                  sx={{ marginRight: '20px' }}
                  variant='outlined'
                  aria-label='Cancel'
                  color='primary'
                  onClick={() => history.goBack()}
                >
                  CANCEL
                </AdasButton>,
                <AdasButton
                  disabled={!isEnabled}
                  key='2'
                  variant='contained'
                  aria-label='Create Work Order'
                  color='primary'
                  isDebounceEnabled={true}
                  onClick={submitHandler}
                >
                  CREATE WORK ORDER
                </AdasButton>
              ]
            : [
                <AdasButton
                  key='1'
                  sx={{ float: 'left' }}
                  variant='outlined'
                  aria-label='Cancel'
                  color='primary'
                  onClick={() => history.goBack()}
                >
                  Cancel
                </AdasButton>,
                <AdasButton
                  key='2'
                  sx={{ float: 'right' }}
                  variant='contained'
                  aria-label='Cancel'
                  color='primary'
                  isDebounceEnabled={true}
                  onClick={updateVehicleInfo}
                  disabled={disableEdit || !isEnabled}
                >
                  Update
                </AdasButton>
              ]}
        </AdasBox>
        <AdasBox>
          <CaradasSnackbar
            open={openSnackBar}
            message={GENERIC_MESSAGES.SAFETY_SYSTEMS_UPDATED}
            onClose={setOpenSnackBar}
            onUndo={undoSafetySystemHandler}
          />
        </AdasBox>
        <ConfirmModal
          open={showInsuranceChangeModal}
          title='Change Insurance Company?'
          message={
            <AdasBox sx={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', margin: '20px 0' }}>
              <WarningIcon color='warning' sx={{ marginTop: '2px', fontSize: '3rem' }} />
              <AdasTypography variant='subtitle1' className='wordWrap'>
                Changing to or from a National Agreement provider will permanently remove all selected products, resetting your cart to
                $0.00.
              </AdasTypography>
            </AdasBox>
          }
          confirmLabel={BUTTONS_DISPLAY_LABEL.CONFIRM}
          handleContinue={handleInsuranceChangeConfirm}
          handleClose={handleInsuranceChangeCancel}
        />
      </AdasPaper>
    </AdasContainer>
  )
}

VehicleInfoPage.propTypes = {
  title: PropTypes.string,
  fromInvoice: PropTypes.bool,
  fromQuote: PropTypes.bool,
  isNewWorkOrder: PropTypes.bool
}
